import styled from 'styled-components';
import { Typography } from '@mui/material';
import { radius, space } from '@elementary/common-ui/style/utils';

const Wrapper = styled.div`
  border-radius: ${radius('lg')};
  border: 1px solid ${({ theme }) => theme.palette.border.default};
  background: ${({ theme }) => theme.palette.surface.base};
  padding: ${space('lg')};
`;

const Exception = styled(Typography)`
  border: 1px solid ${({ theme }) => theme.palette.status.error.main};
  border-radius: ${radius('sm')};
  background: ${({ theme }) => theme.palette.status.error.bg};
  color: ${({ theme }) => theme.palette.status.error.main};
  padding: ${space('md', 'lg')};
  line-height: normal;
  word-break: break-all;
`;

type Props = {
  exception: string | undefined;
};

const ExceptionCard = ({ exception }: Props) => (
  <Wrapper>
    <Exception>{exception}</Exception>
  </Wrapper>
);

export default ExceptionCard;
